import { ReactNode } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useIsSuperAdmin } from "@/hooks/useIsSuperAdmin";
import { useSmartBack } from "@/lib/navigation-utils";
import { LoadingSkeleton as Skeleton } from "@/components/ui/loading-skeleton";
import { Alert, AlertDescription, AlertTitle } from "@akuna/ui";
import { ShieldAlert } from "lucide-react";

interface SuperAdminGuardProps {
  children: ReactNode;
}

export function SuperAdminGuard({ children }: SuperAdminGuardProps) {
  const { user } = useAuth();
  const { data: isSuperAdmin, isLoading } = useIsSuperAdmin();
  const smartBack = useSmartBack();

  // Loading state
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-full max-w-md space-y-4 p-8">
          <Skeleton className="h-8 w-3/4" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-5/6" />
        </div>
      </div>
    );
  }

  // Authorize by is_super_admin flag only (any super admin can access)
  const isAuthorized = isSuperAdmin === true;

  if (!isAuthorized) {
    // Navigate back immediately and show alert
    setTimeout(() => smartBack("/patients"), 1500);

    return (
      <div className="min-h-screen flex items-center justify-center bg-background p-4">
        <Alert variant="danger" className="max-w-md">
          <ShieldAlert className="h-4 w-4" />
          <AlertTitle>Acesso Negado</AlertTitle>
          <AlertDescription>
            Você não tem permissão para acessar esta área.
            Redirecionando...
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  return <>{children}</>;
}
